import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import {Api} from '../../../utils/Variables';

import {Row, Col, Card} from 'react-bootstrap';

import PsContext from '../../context/PsContext';
import NavSingleItem from './NavSingleItem';
import NavDropdownItem from './NavDropdownItem';


class SideNav extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			
		}
		
	}
	
	componentDidMount(){
		
	}
	
	
	render(){

	 const navItems = (items) => items.map((item, index) => itemType(item, index));

		const itemType = (item, index) => {
			  if (item.children) {
				  if (item.allowed) {
					  if (item.allowed.indexOf(this.props.role) > -1) return <NavDropdownItem key={index} item={item} isSidebarCollapsed={this.props.isSidebarCollapsed} role={this.props.role} />;
				  } else {
			  return <NavDropdownItem key={index} item={item} isSidebarCollapsed={this.props.isSidebarCollapsed} role={this.props.role} />;
				  }
			  } else if (item.divider) {
					//return <NavDivider key={index} />;
			  } else if (item.allowed) {
					  if (item.allowed.indexOf(this.props.role) > -1) return <NavSingleItem item={item} key={index} {...this.props}  />;
				  } else { return <NavSingleItem item={item} key={index} {...this.props} />; }
		};

		
		return(
			<div className="suha-sidenav-wrapper" id="sidenavWrapper">
			{/*<div className="sidenav-profile">
				<div className="user-profile"><img src="img/bg-img/9.jpg" alt=""></div>
				<div className="user-info">
				  <h6 className="user-name mb-0">Suha Sarah</h6>
				  <p className="available-balance">Credit <span>$<span className="counter">461</span></span></p>
				</div>
			</div>*/}
			  
			  <ul className="sidenav-nav ps-0">
				{navItems(this.props.nav.top)}
			  </ul>
			  
			  <div className="go-home-btn" id="goHomeBtn" onClick={this.props.menuClose} >
				<i className="lni lni-arrow-left"></i>
			  </div>
			</div>
		);
	}
	
}
export default SideNav;
